import styled from "styled-components";
import { LargeLoader } from "./DotLoader";
import React from "react";

const OuterContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const InnerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default function CenteredLoader() {
  return (
    <OuterContainer>
      <InnerContainer>
        <LargeLoader />
      </InnerContainer>
    </OuterContainer>
  );
}
